import { Card, CardBody } from './../../components/card/card.jsx';
import { Icon } from '@iconify/react';

function PagesPricing() {
	return (
		<div>
			<ol className="breadcrumb">
				<li className="breadcrumb-item"><a href="#/">PAGES</a></li>
				<li className="breadcrumb-item active">PRICING PAGE</li>
			</ol>
			<h1 className="page-header mb-4">Pricing Page <small>header small text goes here...</small></h1>
			
			<Card>
				<CardBody className="p-0">
					<div className="row gx-0">
						<div className="col-xl-7 position-relative">
							<div className="p-4 p-lg-5">
								<div className="display-5 text-white mb-3">Web Hosting Plan</div>
								<div className="mb-4 font-monospace lh-lg">
									Discover the <b className="text-theme d-inline-flex border-bottom border-1 border-theme">perfect plan</b> for your online presence. In a digital landscape where your website is the gateway to your brand, we offer an array of meticulously crafted hosting plans to suit every ambition and requirement.
								</div>
								<div className="row text-white">
									<div className="col-lg-6">
										<div className="d-flex align-items-center mb-3">
											<Icon className="fs-26px text-theme" icon="solar:cup-star-line-duotone" />
											<div className="flex-1 ps-4 fw-semibold">
												Robust Performance
											</div>
										</div>
										<div className="d-flex align-items-center mb-3">
											<Icon className="fs-26px text-theme" icon="solar:cpu-bolt-line-duotone" />
											<div className="flex-1 ps-4 fw-semibold">
												Scalability Options
											</div>
										</div>
										<div className="d-flex align-items-center mb-3">
											<Icon className="fs-26px text-theme" icon="solar:shield-line-duotone" />
											<div className="flex-1 ps-4 fw-semibold">
												Security First
											</div>
										</div>
										<div className="d-flex align-items-center mb-3">
											<Icon className="fs-26px text-theme" icon="solar:headphones-round-sound-line-duotone" />
											<div className="flex-1 ps-4 fw-semibold">
												24/7 Support
											</div>
										</div>
									</div>
									<div className="col-lg-6">
										<div className="d-flex align-items-center mb-3">
											<Icon className="fs-26px text-theme" icon="solar:monitor-smartphone-line-duotone" />
											<div className="flex-1 ps-4 fw-semibold">
												User-Friendly Control Panel
											</div>
										</div>
										<div className="d-flex align-items-center mb-3">
											<Icon className="fs-26px text-theme" icon="solar:mouse-line-duotone" />
											<div className="flex-1 ps-4 fw-semibold">
												One-Click Installations
											</div>
										</div>
										<div className="d-flex align-items-center mb-3">
											<Icon className="fs-26px text-theme" icon="solar:gift-line-duotone" />
											<div className="flex-1 ps-4 fw-semibold">
												Value-Added Features
											</div>
										</div>
										<div className="d-flex align-items-center mb-3">
											<Icon className="fs-26px text-theme" icon="solar:dollar-line-duotone" />
											<div className="flex-1 ps-4 fw-semibold">
												Money-Back Guarantee
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-xl-5 d-xl-flex align-items-center justify-content-center d-none p-5">
							<img src="/quantum-react/assets/img/pricing/img-1.svg" alt="" height="270" />
						</div>
					</div>
				</CardBody>
			</Card>
			
			<div className="row gx-4 py-5">
				<div className="col-xl-3 col-md-6 py-3 py-xl-5">
					<Card className="h-100">
						<CardBody className="p-4 p-lg-5 d-flex flex-column">
							<div className="d-flex align-items-center">
								<div className="flex-1">
									<div className="h6 font-monospace mb-3">Starter Plan</div>
									<div className="display-6 mb-0 text-theme">$5 <small className="h6 fw-light text-body text-opacity-50">/month*</small></div>
								</div>
								<div>
									<Icon className="display-4 text-theme" icon="solar:usb-line-duotone" />
								</div>
							</div>
							<hr className="my-4" />
							<div className="mb-5 text-body text-opacity-50 flex-1">
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Storage:</span> <b className="text-body fw-semibold">10 GB</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Bandwidth:</span> <b className="text-body fw-semibold">100 GB</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Domain Names:</span> <b className="text-body fw-semibold">1</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">SSL Certificate:</span> <b className="text-body fw-semibold"> Shared</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Email Accounts:</span> <b className="text-body fw-semibold"> 5</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">24/7 Support:</span> <b className="text-body fw-semibold"> Yes</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Backup:</span> <b className="text-body fw-semibold"> Daily</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Uptime Guarantee:</span> <b className="text-body fw-semibold"> 99.9%</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">FTP Access:</span> <b className="text-body fw-semibold"> Yes</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Control Panel:</span> <b className="text-body fw-semibold"> cPanel</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Free Domain:</span> <b className="text-body fw-semibold"> No</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Firewall:</span> <b className="text-body fw-semibold"> No</b></div>
								</div>
							</div>
							<div className="mx-n2">
								<a href="#/" className="btn btn-outline-theme btn-lg py-3 fs-13px w-100 font-monospace">Get Started <i className="fa fa-arrow-right"></i></a>
							</div>
						</CardBody>
					</Card>
				</div>
				<div className="col-xl-3 col-md-6 py-3 py-xl-5">
					<Card className="h-100">
						<CardBody className="p-4 p-lg-5 d-flex flex-column">
							<div className="d-flex align-items-center">
								<div className="flex-1">
									<div className="h6 font-monospace mb-3">Booster Plan</div>
									<div className="display-6 mb-0 text-theme">$10 <small className="h5 text-body text-opacity-50">/month*</small></div>
								</div>
								<div>
									<Icon className="display-4 text-theme" icon="solar:map-arrow-up-line-duotone" />
								</div>
							</div>
							<hr className="my-4" />
							<div className="mb-5 text-body text-opacity-50 flex-1">
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Storage:</span> <b className="text-body fw-semibold">20 GB</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Bandwidth:</span> <b className="text-body fw-semibold">200 GB</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Domain Names:</span> <b className="text-body fw-semibold">2</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">SSL Certificate:</span> <b className="text-body fw-semibold"> Free</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Email Accounts:</span> <b className="text-body fw-semibold"> 10</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">24/7 Support:</span> <b className="text-body fw-semibold"> Yes</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Backup:</span> <b className="text-body fw-semibold"> Daily</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Uptime Guarantee:</span> <b className="text-body fw-semibold"> 99.9%</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">FTP Access:</span> <b className="text-body fw-semibold"> Yes</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Control Panel:</span> <b className="text-body fw-semibold"> cPanel</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Free Domain:</span> <b className="text-body fw-semibold"> No</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Firewall:</span> <b className="text-body fw-semibold"> No</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-times fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">45-Day Money-Back Guarantee</span></div>
								</div>
							</div>
							<div className="mx-n2">
								<a href="#/" className="btn btn-outline-theme btn-lg py-3 fs-13px w-100 font-monospace">Get Started <i className="fa fa-arrow-right"></i></a>
							</div>
						</CardBody>
					</Card>
				</div>
				<div className="col-xl-3 col-md-6 py-3 py-xl-0">
					<Card className="h-100">
						<CardBody className="fs-14px p-4 p-lg-5 d-flex flex-column bg-theme bg-opacity-95">
							<div className="d-flex align-items-center">
								<div className="flex-1">
									<div className="h5 font-monospace mb-3 text-theme-color">Premium Plan</div>
									<div className="display-6 mb-0 text-theme-color fw-semibold">$15 <small className="h5 text-theme-color text-opacity-50">/month*</small></div>
								</div>
								<div>
									<Icon className="display-3 text-theme-color" icon="solar:cup-first-line-duotone" />
								</div>
							</div>
							<hr className="my-4 text-theme-color" />
							<div className="mb-5 text-theme-color text-opacity-50 flex-1">
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check text-theme-color text-opacity-25 fa-lg"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Storage:</span> <b className="text-theme-color fw-semibold">50 GB</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check text-theme-color text-opacity-25 fa-lg"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Bandwidth:</span> <b className="text-theme-color fw-semibold">500 GB</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check text-theme-color text-opacity-25 fa-lg"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Domain Names:</span> <b className="text-theme-color fw-semibold">Unlimited</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check text-theme-color text-opacity-25 fa-lg"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">SSL Certificate:</span> <b className="text-theme-color fw-semibold">Free</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check text-theme-color text-opacity-25 fa-lg"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Email Accounts:</span> <b className="text-theme-color fw-semibold">Unlimited</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check text-theme-color text-opacity-25 fa-lg"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">24/7 Support:</span> <b className="text-theme-color fw-semibold">Yes</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check text-theme-color text-opacity-25 fa-lg"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Backup:</span> <b className="text-theme-color fw-semibold">Daily</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check text-theme-color text-opacity-25 fa-lg"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Uptime Guarantee:</span> <b className="text-theme-color fw-semibold">99.9%</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check text-theme-color text-opacity-25 fa-lg"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">FTP Access:</span> <b className="text-theme-color fw-semibold">Yes</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check text-theme-color text-opacity-25 fa-lg"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Control Panel:</span> <b className="text-theme-color fw-semibold">cPanel</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check text-theme-color text-opacity-25 fa-lg"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Free Domain:</span> <b className="text-theme-color fw-semibold">No</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check text-theme-color text-opacity-25 fa-lg"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Firewall:</span> <b className="text-theme-color fw-semibold">Yes</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check text-theme-color text-opacity-25 fa-lg"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">E-commerce Support</span></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check text-theme-color text-opacity-25 fa-lg"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">45-Day Money-Back Guarantee</span></div>
								</div>
							</div>
							<a href="#/" className="btn btn-black btn-lg py-3 fs-13px w-100 font-monospace">Get Started <i className="fa fa-arrow-right"></i></a>
						</CardBody>
					</Card>
				</div>
				<div className="col-xl-3 col-md-6 py-3 py-xl-5">
					<Card className="h-100">
						<CardBody className="p-4 p-lg-5 d-flex flex-column">
							<div className="d-flex align-items-center">
								<div className="flex-1">
									<div className="h6 font-monospace mb-3">Business Plan</div>
									<div className="display-6 mb-0 text-theme">$99 <small className="h5 text-body text-opacity-50">/month*</small></div>
								</div>
								<div>
									<Icon className="display-4 text-theme" icon="solar:buildings-line-duotone" />
								</div>
							</div>
							<hr className="my-4" />
							<div className="mb-5 text-body text-opacity-50 flex-1">
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Storage:</span> <b className="text-body fw-semibold">1 TB</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Bandwidth:</span> <b className="text-body fw-semibold">20 TB</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Domain Names:</span> <b className="text-body fw-semibold">Unlimited</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">SSL Certificate:</span> <b className="text-body fw-semibold">Free</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Email Accounts:</span> <b className="text-body fw-semibold">Unlimited</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check fa-lg text-body text-opacity-25"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">24/7 Support:</span> <b className="text-body fw-semibold">Yes</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check text-gray-500 fa-lg"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Backup:</span> <b className="text-body fw-semibold"> Daily</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check text-gray-500 fa-lg"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Uptime Guarantee:</span> <b className="text-body fw-semibold">99.9%</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check text-gray-500 fa-lg"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">FTP Access:</span> <b className="text-body fw-semibold">Yes</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check text-gray-500 fa-lg"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Control Panel:</span> <b className="text-body fw-semibold">cPanel</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check text-gray-500 fa-lg"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Free Domain:</span> <b className="text-body fw-semibold">Yes</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check text-gray-500 fa-lg"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">Firewall:</span> <b className="text-body fw-semibold">Yes</b></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check text-gray-500 fa-lg"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">E-commerce Support</span></div>
								</div>
								<div className="d-flex align-items-center mb-2">
									<i className="fa fa-check text-gray-500 fa-lg"></i> 
									<div className="flex-1 ps-4"><span className="font-monospace small">45-Day Money-Back Guarantee</span></div>
								</div>
							</div>
							<div className="mx-n2">
								<a href="#/" className="btn btn-outline-theme btn-lg py-3 fs-13px w-100 font-monospace">Get Started <i className="fa fa-arrow-right"></i></a>
							</div>
						</CardBody>
					</Card>
				</div>
			</div>
		</div>
	)
}

export default PagesPricing;